// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.end-match-scoreboard__form__actions{
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

/* .tournament-end-match-scorerboard__teams__container {
    display: flex;
    justify-content: space-evenly;
    margin-top: var( --space-and-half );
} */

.tournament-end-match-scorerboard__teams__container {
    
    justify-content: center;
    align-items: center;
    margin-top: 90px;
}

.tournament-end-match-scorerboard__teams__container .baloa-names {
    color: var( --basic-gray-color );
    padding-bottom: 17px;
}

.tournament-end-match-scorerboard__teams__container .baloa-headline-2 {
    color: var( --primary-dark-color );
    margin-top: 17px;
    margin-bottom: 8px;
}

.tournament-end-match-scorerboard__teams__container .baloa-normal-text {
    color: var( --basic-gray-color );
}

.tournament-end-match-scorerboard__score-input.input-field {
    margin: auto;
    padding: 0 32px;
}

.tournament-end-match-scorerboard__score-input .input-field__message {
    margin-left: 0;
}

.tournament-end-match-scorerboard__score-input .input-field-input {
    max-height: none;
    width: calc( var( --space-x3 ) + var( --space-x2 ) + var( --space-quarter ) + var( --space-eighth ) );
    height: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-eighth ) );
    background: var( --white-color );
    border-radius: var( --space-quarter  );
    font-family: var( --primary-font );
    font-style: normal;
    font-weight: bold;
    font-size: calc( var( --space-x3 ) + var( --space-half ) + 1px );
    line-height: calc( var( --space-x3 ) + var( --space ) + var( --space-quarter ) );
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: -0.005em;
    color: var( --primary-dark-color );
    border-radius: var( --space-half );
    border: 1px solid var( --new-gray-background-color );
}

.tournament-end-match-scorerboard__score-input .input-field-input::placeholder {
    color: var( --new-gray-disabled-color );
}

.tournament-end-match-scorerboard__teams__container img {
    width: calc( var( --space-x3 ) + var( --space-and-half ) );
    height: calc( var( --space-x3 ) + var( --space-and-half ) );
    border-radius: 50%;
}

.tournament-end-match-scorerboard__teams__container .icon-ball {
    color: var( --white-color );
    font-size: calc( var( --space-x3 ) + var( --space-quarter ) );
    border-radius: 50%;
    padding: calc( var( --space-half ) + var( --space-eighth ) );
}

.tournament-end-match-scoreboard__teams{
    border: 1px solid red;
    border-radius: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 200px;
    width: 50%;
}

.tournament-end-match-scoreboard__teams .baloa-names {
    margin-bottom: calc( var( --space-half-quarter ) + var( --space-eighth ));
}

.tournament-end-match-scoreboard__teams .baloa-headline-2 {
    margin-top: calc( var( --space-half-quarter ) + var( --space-eighth ));
    margin-bottom: var( --space-quarter );
}

.tournament-end-match-scoreboard__teams img {
    border-radius: 50%;
}

.tournament-end-match-scoreboard__teams__data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 270px;
}

.tournament-end-match-scorerboard__penalty-shootouts__container {
    max-width: 54%;
    margin: 0 auto;
}

.tournament-end-match-scorerboard__penalty-shootouts__teams {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-end-match-scorerboard__penalty-shootouts__team {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: calc( calc( 100% - 150px) / 2);
}

.tournament-end-match-scorerboard__penalty-shootouts__team-img {
    margin: 0 var( --space-half-quarter );
}

.tournament-end-match-scorerboard__penalty-shootouts__team-img img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
}

.tournament-end-match-scorerboard__penalty-shootouts__team-img .icon-ball {
    color: var( --white-color );
    font-size: 20px;
    border-radius: 50%;
    padding: 4px;
}

.tournament-end-match-scorerboard__penalty-shootouts__team-name {
    max-width: -webkit-fill-available;
}

.tournament-end-match-scorerboard__penalty-shootouts__team-name .baloa-hyperlink-2 {
    font-weight: var( --font-medium );
    color: var( --primary-dark-color );
    white-space: nowrap;
    text-align: center;
    padding-top: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.tournament-end-match-scorerboard__penalty-shootouts__team-name .baloa-username {
    font-size: var( --space-half-quarter );
    line-height: calc( var(--space-half-quarter) + var(--space-eighth) );
    color: var( --primary-dark-color );
    text-align: center;
}

.tournament-end-match-scorerboard__shootout-score-input .input-field-input {
    max-height: none;
    width: calc( var( --space-x3 ) + var( --space-eighth ) );
    height: calc( var( --space-x3 ) + var( --space-eighth ) );
    background: var( --white-color );
    border-radius: var( --space-quarter  );
    font-family: var( --primary-font );
    font-style: normal;
    font-weight: bold;
    font-size: calc( var( --space ) + 1px );
    line-height: calc( var(--space) + var( --space-quarter ) );
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: -0.005em;
    color: var( --primary-dark-color );
    border: 1px solid var( --new-gray-background-color );
    padding: 0;
}

.tournament-end-match-scorerboard__shootout-score-input {
    margin: 0;
}

.tournament-end-match-scorerboard__shootouts__container {
    padding: var( --space ) var( --space-x2 );
    border: 1px solid var( --new-gray-background-color );
    border-radius: var( --space-half-quarter );
}

.tournament-end-match-scorerboard__penalty-shootouts__team-score {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-evenly;
    min-width: 150px;
}

.tournament-end-match-scorerboard__penalty-shootouts__team-score .baloa-hyperlink-2 {
    color: var(--primary-dark-color);
    text-align: center;
    width: 100%;
    padding-bottom: 14px;
}

.tournament-end-match-scorerboard__penalty-shootouts__switch-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-end-match-scorerboard__penalty-shootouts__switch-container .baloa-hyperlink-2 {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
    padding: 17px 0;
}

.tournament-end-match-scorerboard__penalty-shootouts__switch-container .MuiSwitch-root {
    display: flex;
    align-items: center;
}

.tournament-end-match-scorerboard__teams__container__scoreboard{
    /* display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid green;
    border-radius: 12px;
    margin: 0 auto;
    width: fit-content;
    padding: 16px; */
    display: grid;
    /* grid-template-columns: 3fr 2fr 1fr 2fr 3fr; */
    grid-template-columns: auto auto auto auto auto;
    grid-auto-columns: min-content;
    width: fit-content;
    padding: 22px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 12px;
    margin: 0 auto;
    justify-content: center;
    align-content: center;
}

.tournament-end-match-scoreboard__teams__divisor{
    width: 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
}

.tournament-end-match-scorerboard__teams__container__title {
    color: blue; 
    grid-area: 1 / 1 / 1 / 6;   
    position: relative;
    top: -60px;
}

.tournament-end-match-scorerboard__teams__container__title.baloa-table {
    color: var(--primary-very-dark-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-end-match-scoreboard/TournamentEndMatchScoreboardComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;;;GAIG;;AAEH;;IAEI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,qGAAqG;IACrG,6EAA6E;IAC7E,gCAAgC;IAChC,sCAAsC;IACtC,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,gEAAgE;IAChE,gFAAgF;IAChF,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,kCAAkC;IAClC,oDAAoD;AACxD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0DAA0D;IAC1D,2DAA2D;IAC3D,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,6DAA6D;IAC7D,kBAAkB;IAClB,4DAA4D;AAChE;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;IACI,sEAAsE;IACtE,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,oEAAoE;IACpE,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,wDAAwD;IACxD,yDAAyD;IACzD,gCAAgC;IAChC,sCAAsC;IACtC,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;IACvC,0DAA0D;IAC1D,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,oDAAoD;IACpD,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yCAAyC;IACzC,oDAAoD;IACpD,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;;;;;;;oBAOgB;IAChB,aAAa;IACb,gDAAgD;IAChD,+CAA+C;IAC/C,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,kDAAkD;IAClD,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".end-match-scoreboard__form__actions{\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n/* .tournament-end-match-scorerboard__teams__container {\n    display: flex;\n    justify-content: space-evenly;\n    margin-top: var( --space-and-half );\n} */\n\n.tournament-end-match-scorerboard__teams__container {\n    \n    justify-content: center;\n    align-items: center;\n    margin-top: 90px;\n}\n\n.tournament-end-match-scorerboard__teams__container .baloa-names {\n    color: var( --basic-gray-color );\n    padding-bottom: 17px;\n}\n\n.tournament-end-match-scorerboard__teams__container .baloa-headline-2 {\n    color: var( --primary-dark-color );\n    margin-top: 17px;\n    margin-bottom: 8px;\n}\n\n.tournament-end-match-scorerboard__teams__container .baloa-normal-text {\n    color: var( --basic-gray-color );\n}\n\n.tournament-end-match-scorerboard__score-input.input-field {\n    margin: auto;\n    padding: 0 32px;\n}\n\n.tournament-end-match-scorerboard__score-input .input-field__message {\n    margin-left: 0;\n}\n\n.tournament-end-match-scorerboard__score-input .input-field-input {\n    max-height: none;\n    width: calc( var( --space-x3 ) + var( --space-x2 ) + var( --space-quarter ) + var( --space-eighth ) );\n    height: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-eighth ) );\n    background: var( --white-color );\n    border-radius: var( --space-quarter  );\n    font-family: var( --primary-font );\n    font-style: normal;\n    font-weight: bold;\n    font-size: calc( var( --space-x3 ) + var( --space-half ) + 1px );\n    line-height: calc( var( --space-x3 ) + var( --space ) + var( --space-quarter ) );\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: -0.005em;\n    color: var( --primary-dark-color );\n    border-radius: var( --space-half );\n    border: 1px solid var( --new-gray-background-color );\n}\n\n.tournament-end-match-scorerboard__score-input .input-field-input::placeholder {\n    color: var( --new-gray-disabled-color );\n}\n\n.tournament-end-match-scorerboard__teams__container img {\n    width: calc( var( --space-x3 ) + var( --space-and-half ) );\n    height: calc( var( --space-x3 ) + var( --space-and-half ) );\n    border-radius: 50%;\n}\n\n.tournament-end-match-scorerboard__teams__container .icon-ball {\n    color: var( --white-color );\n    font-size: calc( var( --space-x3 ) + var( --space-quarter ) );\n    border-radius: 50%;\n    padding: calc( var( --space-half ) + var( --space-eighth ) );\n}\n\n.tournament-end-match-scoreboard__teams{\n    border: 1px solid red;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    min-width: 200px;\n    width: 50%;\n}\n\n.tournament-end-match-scoreboard__teams .baloa-names {\n    margin-bottom: calc( var( --space-half-quarter ) + var( --space-eighth ));\n}\n\n.tournament-end-match-scoreboard__teams .baloa-headline-2 {\n    margin-top: calc( var( --space-half-quarter ) + var( --space-eighth ));\n    margin-bottom: var( --space-quarter );\n}\n\n.tournament-end-match-scoreboard__teams img {\n    border-radius: 50%;\n}\n\n.tournament-end-match-scoreboard__teams__data {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 270px;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__container {\n    max-width: 54%;\n    margin: 0 auto;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__teams {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__team {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    max-width: calc( calc( 100% - 150px) / 2);\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__team-img {\n    margin: 0 var( --space-half-quarter );\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__team-img img {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__team-img .icon-ball {\n    color: var( --white-color );\n    font-size: 20px;\n    border-radius: 50%;\n    padding: 4px;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__team-name {\n    max-width: -webkit-fill-available;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__team-name .baloa-hyperlink-2 {\n    font-weight: var( --font-medium );\n    color: var( --primary-dark-color );\n    white-space: nowrap;\n    text-align: center;\n    padding-top: 12px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__team-name .baloa-username {\n    font-size: var( --space-half-quarter );\n    line-height: calc( var(--space-half-quarter) + var(--space-eighth) );\n    color: var( --primary-dark-color );\n    text-align: center;\n}\n\n.tournament-end-match-scorerboard__shootout-score-input .input-field-input {\n    max-height: none;\n    width: calc( var( --space-x3 ) + var( --space-eighth ) );\n    height: calc( var( --space-x3 ) + var( --space-eighth ) );\n    background: var( --white-color );\n    border-radius: var( --space-quarter  );\n    font-family: var( --primary-font );\n    font-style: normal;\n    font-weight: bold;\n    font-size: calc( var( --space ) + 1px );\n    line-height: calc( var(--space) + var( --space-quarter ) );\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: -0.005em;\n    color: var( --primary-dark-color );\n    border: 1px solid var( --new-gray-background-color );\n    padding: 0;\n}\n\n.tournament-end-match-scorerboard__shootout-score-input {\n    margin: 0;\n}\n\n.tournament-end-match-scorerboard__shootouts__container {\n    padding: var( --space ) var( --space-x2 );\n    border: 1px solid var( --new-gray-background-color );\n    border-radius: var( --space-half-quarter );\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__team-score {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    min-width: 150px;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__team-score .baloa-hyperlink-2 {\n    color: var(--primary-dark-color);\n    text-align: center;\n    width: 100%;\n    padding-bottom: 14px;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__switch-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__switch-container .baloa-hyperlink-2 {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n    padding: 17px 0;\n}\n\n.tournament-end-match-scorerboard__penalty-shootouts__switch-container .MuiSwitch-root {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-end-match-scorerboard__teams__container__scoreboard{\n    /* display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid green;\n    border-radius: 12px;\n    margin: 0 auto;\n    width: fit-content;\n    padding: 16px; */\n    display: grid;\n    /* grid-template-columns: 3fr 2fr 1fr 2fr 3fr; */\n    grid-template-columns: auto auto auto auto auto;\n    grid-auto-columns: min-content;\n    width: fit-content;\n    padding: 22px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 12px;\n    margin: 0 auto;\n    justify-content: center;\n    align-content: center;\n}\n\n.tournament-end-match-scoreboard__teams__divisor{\n    width: 20px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin: auto;\n}\n\n.tournament-end-match-scorerboard__teams__container__title {\n    color: blue; \n    grid-area: 1 / 1 / 1 / 6;   \n    position: relative;\n    top: -60px;\n}\n\n.tournament-end-match-scorerboard__teams__container__title.baloa-table {\n    color: var(--primary-very-dark-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
